import { Dialog, IconButton, Typography, styled } from '@mui/material';

const PREVIEW_BG = '#121212';

export const PreviewDialog = styled(Dialog)({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
  },
  '& .MuiDialog-container': {
    height: '100%',
    width: '100%',
    overflow: 'hidden !important',
  },
  '& .MuiPaper-root': {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    backgroundColor: PREVIEW_BG,
    boxShadow: 'none',
  },
});

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: PREVIEW_BG,
  position: 'relative',
});

export const TopBar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '8px 12px 8px 16px',
  minHeight: '56px',
  flexShrink: 0,
  pointerEvents: 'none',
});

export const FileName = styled(Typography)({
  color: '#fff',
  fontWeight: 600,
  fontSize: '1rem',
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flex: 1,
  minWidth: 0,
  maxWidth: 'calc(100% - 300px)',
  pointerEvents: 'auto',
});

export const CloseButton = styled(IconButton)({
  pointerEvents: 'auto',
  width: '40px',
  height: '40px',
  borderRadius: '8px',
  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
    fontSize: '20px',
    color: '#ffffff !important',
    fill: '#ffffff !important',
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    color: '#ffffff !important',
  },
});

export const Content = styled('div')({
  flex: 1,
  minHeight: 0,
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overscrollBehavior: 'contain',
  '& .react-doc-viewer': {
    height: '100% !important',
  },
});

export const IFrame = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none',
  display: 'block',
  backgroundColor: '#fff',
});
